type Params = {
  stableToDollar?: boolean;
  showPlusSign?: boolean;
};

const getSign = (num: number | string, showPlusSign: boolean): string => {
  if (Number(num) > 0 && showPlusSign) {
    return '+';
  } else if (Number(num) < 0) {
    return '-';
  }

  return '';
};

function removeSign<T extends string | number>(input: T): string {
  const strInput = String(input);

  return strInput.replace(/^[-+]/, '');
}

export const concatCurrencyToAmount = (
  amount: number | string,
  currency: string,
  params: Params = {},
): string => {
  const { stableToDollar = true, showPlusSign = false } = params;
  const parsedCurrency = stableToDollar && currency.toLowerCase() === 'usdt' ? '$' : currency;

  const sign = getSign(amount, showPlusSign);
  const amountWithoutSign = removeSign(amount);

  if (parsedCurrency === '$') {
    return `${sign}$${amountWithoutSign}`;
  }

  return `${sign}${amountWithoutSign} ${parsedCurrency}`;
};
